import type { KeyboardShortcut } from "./keyboardShortcuts";
import { useEventListener } from "@vueuse/core";

export type UseKeyboardShortcutOptions = AddEventListenerOptions;

export function useKeyboardShortcut(shortcut: KeyboardShortcut, handler: (e: KeyboardEvent) => unknown, options: UseKeyboardShortcutOptions = {}) {
  return useEventListener("keydown", e => {
    if (shortcut.isPressed(e)) {
      handler(e);
    }
  }, options);
}

export function isEventConsideredHandled(event: KeyboardEvent | MouseEvent | ClipboardEvent): boolean {
  const target = event.target;
  if (!event.target) return false;
  if (!(target instanceof HTMLElement)) return false;
  return target.tagName === "INPUT"
    || target.tagName === "TEXTAREA"
    || target.isContentEditable
    // is at the end of prosemirror
    || target.classList.contains("ProseMirror-trailingBreak")
    // is within prosemirror
    || !!target.closest(".ProseMirror")
    // within popover or menu
    || !!target.closest("[data-dismissable-layer]")
    // within bubble menu
    || !!target.closest("[data-axure-bubble-menu]");
}

export function useUnhandledKeyboardShortcut(shortcut: KeyboardShortcut, handler: (e: KeyboardEvent) => unknown, options: UseKeyboardShortcutOptions = {}) {
  return useKeyboardShortcut(shortcut, e => {
    if (isEventConsideredHandled(e)) {
      return;
    }
    handler(e);
  }, options);
}
